var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationMessengerWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "24px",
    viewBox: "0 0 17 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationMessengerWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sent",
    transform: "translate(-230.000000, -491.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(216.000000, 482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34376808,0 C11.3641629,0 14.6875362,2.97468274 14.6875362,7.24387497 C14.6875362,8.78990513 14.2491486,10.4437053 13.5400724,11.6874513 L7.81975306,21.7232462 C7.7239236,21.8940188 7.54164791,22 7.34376808,22 C7.14588826,22 6.96361256,21.8940188 6.86778311,21.7232462 L1.14746376,11.6874513 C0.438414795,10.443759 0,8.78990513 0,7.24387497 C0,2.97468274 3.32337329,0 7.34376808,0 Z M7.34376808,3.75608193 C5.39738667,3.75608193 3.80787975,5.32400466 3.80787975,7.24387497 C3.80787975,9.16376942 5.3973921,10.7316626 7.34376808,10.7316626 C9.29014406,10.7316626 10.8796564,9.16376942 10.8796564,7.24387497 C10.8796564,5.32400466 9.2901495,3.75608193 7.34376808,3.75608193 Z",
    id: "icLocationMessengerWhite"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationMessengerWhite);
export default __webpack_public_path__ + "static/media/icLocationMessengerWhite.7b406a6b467611d97bba1649277a2bbf.svg";
export { ForwardRef as ReactComponent };